import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { convertViolatedRequirementsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolatedRequirementsFormValuesToKnmData';
import { IKnmActFamiliarizationNotifications } from 'APIPackage/KnmModule/interfaces/IKnmActFamiliarizationNotifications';
import { store } from 'CorePackage/MainModule/common/store';
import { getDirtyResultDecisionGuid } from 'CorePackage/HeaderModule/reducers/headerReducer';
import { convertFormDateTimeValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';

import { IKnmPmFormResultDecision } from '../interfaces/IKnmPmFormResultDecision';
import { convertSubjectFormValuesToKnmData } from '../../../KnmPackage/KnmSubjectModule/common/convertSubjectFormValuesToKnmData';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertPmResultDecisionsFormToKnmData = (
  pmResultDecisions?: IKnmPmFormResultDecision[],
  isDraft?: boolean,
  actGuid?: string | null,
): NonNullable<IPm['subject']>['pmResultDecisions'] => {
  const state = store.getState();
  const dirtyResultDecisionGuid = getDirtyResultDecisionGuid(state);

  return (
    pmResultDecisions?.map(item => {
      return {
        isNew: isDraft ? item.isNew : null,
        actGuid: item.actGuid || actGuid || null,
        guid: item.guid || null,
        status: item.status || null,
        agreementStatus: item.agreementStatus || null,
        dateCreate: item.dateCreate || null,
        number: item.number || null,
        date: convertFormDateTimeValueToKnmDataDate(item.date, true),
        dateResolvedByAgreement: convertFormDateTimeValueToKnmDataDate(item.dateResolvedByAgreement),
        kindDecision: item.kindDecision ? deleteObjectProperties(item.kindDecision, ['label', 'value']) : null,
        deadline: convertFormDateValueToKnmDataDate(item.deadline),
        information: item.information || null,
        informationReactQuillEditor: handleReactQuillDeltaValue(item.informationReactQuillEditor || item.information),
        fioSigner: item.signerFullName || null,
        titleSigner: item.signerPosition?.value || null,
        subjectType: item.subjectType?.value || null,
        attachment: convertKnmDocumentAttachmentsFormValuesToKnmData([item.attachment])?.pop() || null,
        founder:
          (item.founder &&
            convertSubjectFormValuesToKnmData({
              isOrganizationNew: true,
              ...item.founder,
            })) ||
          null,
        violations: convertViolatedRequirementsFormValuesToKnmData(item.violatedMandatoryRequirements),
        signed: dirtyResultDecisionGuid && dirtyResultDecisionGuid === item.guid ? false : item.signed ?? null,
        paperless: item.paperless || null,
        extractVersion: item.extractVersion || null,
        familiarizationNotifications:
          item?.familiarizationNotifications?.map(x => {
            const notification: IKnmActFamiliarizationNotifications = {
              noticeDate: convertFormDateValueToKnmDataDate(x.noticeDate),
              knmNoticeType: x.knmNoticeType || null,
              note: x.note || null,
              guid: x.listId,
              isNew: x.isNew,
            };

            return notification;
          }) || null,
        firstExtractDateTime: convertFormDateTimeValueToKnmDataDate(item.firstExtractDateTime) || null,

        systemSignatureUsed: item.systemSignatureUsed || false,
        systemSignatureTitle: item.systemSignatureTitle || null,
        systemSignatureDateTime: item.systemSignatureDateTime || null,
        systemSignatureMnemonic: item.systemSignatureMnemonic || null,
        cancelComment: item.cancelComment || null,
        cancelFioSigner: item.cancelFioSigner
          ? item.cancelFioSigner
          : state.knm.prescribeDataForSign?.fioSigner || null,
        cancelTitleSigner: item.cancelTitleSigner?.value
          ? item.cancelTitleSigner?.value
          : state.knm.prescribeDataForSign?.signerPosition?.value || null,
        cancelDocument: convertKnmDocumentAttachmentsFormValuesToKnmData([item.cancelDocument])?.pop() || null,
        isCancelSigned: item.isCancelSigned || null,
        dateAdded: item.dateAdded || null,
      };
    }) || null
  );
};
